import { render, staticRenderFns } from "./PersonaNotes.vue?vue&type=template&id=0ed5968a&"
import script from "./PersonaNotes.vue?vue&type=script&lang=js&"
export * from "./PersonaNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports